export const PDFPaperSize = {
  Landscape: "Landscape",
  Portrait: "Portrait",
};
